import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';
import { SUBSCRIPTION_HEADER_NAME } from '../constants/constants';
import { saveFile } from '../helpers/saveFile';
import { API_ROOT } from '../helpers/apiConfig';

export const actions = {
    searchBaselines: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baseline/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_BASELINE_REQUEST,
                        types.SEARCH_BASELINE_SUCCESS,
                        types.SEARCH_BASELINE_FAILURE
                    ]
                }
            });
        },
    getBaseline: (id) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baseline/' + id,
                    method: 'GET',
                    types: [
                        types.GET_BASELINE_REQUEST,
                        types.GET_BASELINE_SUCCESS,
                        types.GET_BASELINE_FAILURE
                    ]
                }
            });
        },
    loadFilters: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baseline/filters',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.LOAD_BASELINE_FILTERS_REQUEST,
                        types.LOAD_BASELINE_FILTERS_SUCCESS,
                        types.LOAD_BASELINE_FILTERS_FAILURE
                    ]
                }
            });
        },
    loadList: (subId) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baseline/list',
                    method: 'POST',
                    body: { subscriptionId: subId },
                    types: [
                        types.LOAD_BASELINE_LIST_REQUEST,
                        types.LOAD_BASELINE_LIST_SUCCESS,
                        types.LOAD_BASELINE_LIST_FAILURE
                    ]
                }
            });
        },

    saveBaseline: (baseline) =>
        (dispatch) => {
            if (baseline.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'baseline/create',
                        method: 'POST',
                        body: baseline,
                        types: [
                            types.CREATE_BASELINE_REQUEST,
                            types.CREATE_BASELINE_SUCCESS,
                            types.CREATE_BASELINE_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'baseline/update',
                        method: 'PUT',
                        body: baseline,
                        types: [
                            types.UPDATE_BASELINE_REQUEST,
                            types.UPDATE_BASELINE_SUCCESS,
                            types.UPDATE_BASELINE_FAILURE
                        ]
                    }
                });
            }
        },
    loadPushdownLocations: () =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baseline/pushdown-locations',
                    method: 'GET',
                    types: [
                        types.LOAD_PUSHDOWN_LOCATIONS_REQUEST,
                        types.LOAD_PUSHDOWN_LOCATIONS_SUCCESS,
                        types.LOAD_PUSHDOWN_LOCATIONS_FAILURE
                    ]
                }
            });
        },
    pushdown: (request) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baseline/pushdown',
                    method: 'POST',
                    body: request,
                    types: [
                        types.PUSHDOWN_BASELINE_REQUEST,
                        types.PUSHDOWN_BASELINE_SUCCESS,
                        types.PUSHDOWN_BASELINE_FAILURE
                    ]
                }
            });
        },
    previewPushdown: (baselineId, openingDate) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baseline/preview-pushdown',
                    method: 'POST',
                    body: { baselineId: baselineId, openingDate: openingDate },
                    types: [
                        types.PREVIEW_BASELINE_PUSHDOWN_REQUEST,
                        types.PREVIEW_BASELINE_PUSHDOWN_SUCCESS,
                        types.PREVIEW_BASELINE_PUSHDOWN_FAILURE
                    ]
                }
            });
        },
    import: (baselineId, file) =>
        (dispatch) => {
            let body = new FormData();
            body.append('file', file);
            body.append('baselineId', baselineId);

            return dispatch({
                [CALL_API]: {
                    endpoint: 'baseline/import',
                    method: 'POST',
                    body: body,
                    types: [
                        types.IMPORT_BASELINE_REQUEST,
                        types.IMPORT_BASELINE_SUCCESS,
                        types.IMPORT_BASELINE_FAILURE
                    ]
                }
            });
        },
    copyBaseline: (request) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'baseline/copy',
                    method: 'POST',
                    body: request,
                    types: [
                        types.COPY_BASELINE_REQUEST,
                        types.COPY_BASELINE_SUCCESS,
                        types.COPY_BASELINE_FAILURE
                    ]
                }
            });
        },
    importTemplate: (templateType) => {
        return (dispatch, getState) => {
            const endpoint = `baseline/import-template/${templateType}`;
            const method = 'GET';
            let headers = {};
            const token = getState().user.accessToken;
            if (typeof token === "string") {
                headers.Authorization = `Bearer ${token}`;
            }
            const subscriptionId = getState().user.currentSubscriptionId;
            if (subscriptionId) {
                headers[SUBSCRIPTION_HEADER_NAME] = subscriptionId;
            }

            return (
                // eslint-disable-next-line no-undef
                fetch(`${API_ROOT}${endpoint}`, {
                    method,
                    headers,
                    credentials: "same-origin"
                })
                .then(async response => {
                    await saveFile(response);
                })
                .catch(error => {
                    return error;
                })
            );
        }
    },
}
